import { Tag } from "@/schema"
import { ComboboxInput } from "@ui/forms/inputs/combobox-input"

import { EntityLabelSelector } from "@/components/shared/entity-label-selector"

interface TaskLabelSelectorProps {
  id?: string
  label?: Tag | null
  labelId?: string | null
  onLabelChange: (label: Tag | null) => void
  triggerButton?: React.ReactNode
  disabled?: boolean
  contentProps?: React.ComponentPropsWithoutRef<typeof ComboboxInput>["contentProps"]
  className?: string
  error?: boolean
}

export function TaskLabelSelector(props: TaskLabelSelectorProps) {
  return <EntityLabelSelector entityType="task" {...props} />
}
